export enum FileEnum {
  IMAGE = 'image',
  PDF = 'pdf',
}
